import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CommonModule } from '@angular/common';
import { NewsFeedComponent } from './news-feed.component';

const routes: Routes = [
  {
    path: '',
    component: NewsFeedComponent
  }
];

@NgModule({
  declarations: [NewsFeedComponent],
  imports: [RouterModule.forChild(routes), CommonModule],
  exports: [RouterModule],
  providers: []
})
export class NewsFeedModule {}
